<p-toast></p-toast>

<div *ngIf="product as prod else loading">
  <p-blockUI [blocked]="notReady">
    <p-progressSpinner></p-progressSpinner>
  </p-blockUI>

  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <p-splitButton label="Скопировать" icon="pi pi-copy" [model]="items" styleClass="p-button-success mr-2 hide-label" [disabled]="(_prodId == 0)" (onClick)="doCopyProduct(product)"
                     pTooltip="Новый товар на основе" tooltipPosition="top"></p-splitButton>

      <p-button label="Export" icon="pi pi-upload" styleClass="p-button-help mr-2 hide-label"
                (onClick)="exportProduct()"
                [disabled]="!lastConfirmedProduct" pTooltip="Экспортировать данные о товаре" tooltipPosition="top"></p-button>

      <!--<p-button label="Цены" icon="pi pi-money-bill" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openProductPrice($event)"
                pTooltip="Расчет цен" tooltipPosition="top"></p-button>
      <p-button label="История" icon="pi pi-cog" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openHistoryOfUse($event)" *ngIf="productIsSimple"
                pTooltip="История использования" tooltipPosition="top"></p-button>
      <p-button label="Состав" icon="pi pi-cog" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openBillOfMaterials($event)" *ngIf="!productIsSimple"
                pTooltip="Состав изделия" tooltipPosition="top"></p-button>
      <p-button label="Резервы" icon="pi pi-shopping-cart" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openBooking($event)" *ngIf="_prodId"
                pTooltip="Резервирование товара" tooltipPosition="top"></p-button>
      <p-button label="Аналитика" icon="pi pi-chart-bar" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openAnalytics($event)" *ngIf="_prodId"
                pTooltip="Краткая информация о движении товара" tooltipPosition="top" [disabled]="(analiticsIsReady == false)"></p-button>
      <p-button label="Оборотка" icon="pi pi-list" styleClass="p-button-secondary mr-6 hide-label" (onClick)="openTurnoverSheet($event)" *ngIf="_prodId"
                pTooltip="Оборотная ведомость" tooltipPosition="top" [disabled]="(turnOverIsReady == false)"></p-button>-->
    </ng-template>

    <ng-template pTemplate="right">
      <p-menubar [model]="navigationMenu" styleClass="ml-2 mr-2 " />

      <p-button label="Save" icon="pi pi-save" styleClass="p-button-success hide-label" (onClick)="buttonSaveAllClick($event)"
                [disabled]="!prodCodeValid || noChangesThere" pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>
    </ng-template>
  </p-toolbar>

  <p-accordion #editProdAcc [multiple]="true" (onOpen)="onTabOpen($event)">
    <p-accordionTab [(selected)]="tabActiveState[0]" [cache]="false">
      <ng-template pTemplate="header">
        <h3 #aTabMainInfo id="aTabMainInfo">Товар: {{prod.PRODCODE}}</h3><sup>({{_prodId}})</sup>

        <p-button icon="pi pi-copy" styleClass="p-button-information ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="prod.PRODCODE" (onClick)="copyClipBoard(prod.PRODCODE);$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать название в буфер обмена" tooltipPosition="top">
        </p-button>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>

      </ng-template>
      <div class="formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-6 xl:col-6 sm:col-12">
          <label for="PPC" class="do-not-wrap-text">Код товара</label>
          <div class="p-inputgroup">
            <input id="PPC" type="text" pInputText [(ngModel)]="prod.PRODCODE" [value]="prod.PRODCODE | pipetrimstr"
                   (keyup)="checkProdCode($event)"
                   aria-describedby="PPC-help"
                   [class.ng-invalid]="!prodCodeValid"
                   [class.ng-dirty]="!prodCodeValid"
                   [class.field-changed]="hasChangedProperty('PRODCODE')"
                   [disabled]="notReady || !editCodeAllowed" />
            <p-button icon="pi pi-question" (onClick)="onAskEditing()"
                      pTooltip="Запросить разрешение на редактирование" tooltipPosition="top" *ngIf="prod.PRODKIND == 1"></p-button>
            <small id="PPC-help" class="p-error" *ngIf="!prodCodeValid">ОШИБКА ПРИ ВВОДЕ! Код товара короткий или существует</small>
          </div>
        </div>
        <div class="field col-2 xl:col-2 sm:col-12">
          <label for="PPA" class="do-not-wrap-text">Артикул</label>
          <input id="PPA" type="text" pInputText [(ngModel)]="prod.PRODARTICUL" [value]="prod.PRODARTICUL | pipetrimstr "
                 [disabled]="notReady" placeholder="Введите Артикул"
                 [class.field-changed]="hasChangedProperty('PRODARTICUL')"/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-12">
          <div class="field">
            <label for="actcSelector" class="do-not-wrap-text">Таможенный код (УКТЗЕД)</label>
            <div class="p-inputgroup">
              <p-button *ngIf="customsCodeApproved" icon="pi pi-check" styleClass="p-button-success mr-1" [disabled]="!noChangesThere" pTooltip="Код подтвержден!" tooltipPosition="top"></p-button>
              <p-button *ngIf="!customsCodeApproved" icon="pi pi-check" styleClass="p-button-warning mr-1"
                        [disabled]="!noChangesThere"
                        (onClick)="approveCustomsCode()" pTooltip="Подтвердить код" tooltipPosition="top"></p-button>
              <p-dropdown id="actcSelector" [options]="prod.ACTC_LIST"
                          [(ngModel)]="prod.PRODCUSTCODE"
                          [editable]="true"
                          optionLabel="ACTC_STRING"
                          optionValue="ACTC_STRING"
                          optionDisabled="disabled"
                          placeholder="Введите код УКТЗЕД"
                          (onChange)="onActcChange($event)"
                          (onClick)="onActcClick($event)"
                          [styleClass]="hasChangedProperty('PRODCUSTCODE') ? 'field-changed' : ''"
                          >
                <!--<ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
                    <div>{{ codes.ACTC_STRING }}</div>
                  </div>
                </ng-template>-->

                <ng-template let-codes pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>{{ codes.ACTC_STRING }} , {{ codes.ACTC_DATE  | date: 'dd.MM.yyyy' }}, {{ codes.ACTC_SOURCE }} </div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>

        <div class="field col-2 xl:col-2 sm:col-12">
          <label for="PPB" class="do-not-wrap-text">Штрих-код (EAN)</label>
          <input id="PPB" type="text" pInputText [(ngModel)]="prod.PRODBARCODEMASK"
                 [value]="prod.PRODBARCODEMASK | pipetrimstr "
                 [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODBARCODEMASK')"/>
        </div>
        <div class="field col-12">
          <label for="PPN" class="do-not-wrap-text">Описание для документов</label>
          <input id="PPN" type="text" pInputText [(ngModel)]="prod.PRODNAME" [value]="prod.PRODNAME | pipetrimstr "
                 aria-describedby="PPN-help"
                 [class.ng-invalid]="!prodNameValid"
                 [class.ng-dirty]="!prodNameValid"
                 [class.field-changed]="hasChangedProperty('PRODNAME')"
                 [disabled]="notReady" />
          <small id="PPN-help" class="p-error" *ngIf="!prodNameValid">ОШИБКА ПРИ ВВОДЕ! Описание товара слишком длинное или отсутствует</small>
        </div>
        <div class="field col-12">
          <label for="PPD" class="do-not-wrap-text">Дополнительная информация</label>
          <input id="PPD" type="text" pInputText [(ngModel)]="prod.PRODDESCRIPTION" [value]="prod.PRODDESCRIPTION | pipetrimstr "
                 aria-describedby="PPD-help"
                 [class.ng-invalid]="!prodDescValid"
                 [class.ng-dirty]="!prodDescValid"
                 [class.field-changed]="hasChangedProperty('PRODDESCRIPTION')"
                 [disabled]="notReady" />
          <small id="PPD-help" class="p-warning" *ngIf="!prodDescValid">ВНИМАНИЕ! Слишком длинное описание, будет усечено при сохранении</small>
        </div>
        <div class="field col-12">
          <label for="PPN1" class="do-not-wrap-text">Название для бухгалтерии</label>
          <input id="PPN1" type="text" pInputText [(ngModel)]="prod.PRODNOTE" [value]="prod.PRODNOTE | pipetrimstr "
                 aria-describedby="PPN1-help"
                 [class.ng-invalid]="!prodNoteValid"
                 [class.ng-dirty]="!prodNoteValid"
                 [class.field-changed]="hasChangedProperty('PRODNOTE')"
                 [disabled]="notReady" />
          <small id="PPN1-help" class="p-warn" *ngIf="!prodNoteValid">ВНИМАНИЕ! Слишком длинное описание, будет усечено при сохранении</small>
        </div>

        <div class="field col-12">
          <label for="PWW" class="do-not-wrap-text">Ссылка на товар</label>
          <input id="PWW" type="text" pInputText [(ngModel)]="prod.PRODWWWPAGE" [value]="prod.PRODWWWPAGE | pipetrimstr "
                 class="" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODWWWPAGE') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PPW" class="do-not-wrap-text">Вес (кг)</label>
          <input id="PPW" type="number" pInputText [(ngModel)]="prod.PRODWEIGHT" min="0" step="0.1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODWEIGHT') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PPQ" class="do-not-wrap-text">Упаковка</label>
          <input id="PPQ" type="number" pInputText [(ngModel)]="prod.PRODPACK" min="0" step="1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODPACK') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PWP" class="do-not-wrap-text">Вес упаковки (кг)</label>
          <input id="PWP" type="number" pInputText [(ngModel)]="prod.PRODPACKGW" min="0" step="0.1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODPACKGW') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PPV" class="do-not-wrap-text">Объем упаковки</label>
          <input id="PPV" type="number" pInputText [(ngModel)]="prod.PRODPACKVOL" min="0" step="0.1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODPACKVOL') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PDT" class="do-not-wrap-text">Срок поставки (дни)</label>
          <input id="PDT" type="number" pInputText [(ngModel)]="prod.PRODDELTERM" min="0" step="1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODDELTERM') "/>
        </div>

        <div class="field col-2 xl:col-2 sm:col-4 ">
          <label for="PWT" class="do-not-wrap-text">Гарантийный срок (дни)</label>
          <input id="PWT" type="number" pInputText [(ngModel)]="prod.PRODWARRANTY" min="1" step="1" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODWARRANTY') "/>
        </div>
      </div>

      <div class="grid align-items-stretch vertical-container" appStopAccordionHomeEnd>
        <div class="xl:col-3 sm:col-12">
          <div class="box box-stretched">
            <div class="fluid">
              <app-prodgroupselector labelKey="Группа товара" [prodGroupId]="prod.PRODGROUP" (selectedGroup)="prodGroupSelected($event)" [disabled]="notReady"></app-prodgroupselector>
            </div>
          </div>
        </div>
        <div class="xl:col-3 sm:col-12">
          <app-product-global-category-selector [productId]="prod.PRODID" (selectedProductCategory)="onSelectedProductCategory($event)" labelKey="Глобальная категория" [disabled]="prod.PRODID==-2">
          </app-product-global-category-selector>
        </div>

        <div class="xl:col-3 sm:col-12">
          <div class="box box-stretched">
            <div class="fluid">
              <app-companyselector labelKey="Производитель" [parentCompany]="0" [selectedID]="prod.PRODVENDORID" (selectedCompanyID)="prodVendorSelected($event)" [disabled]="notReady"></app-companyselector>
            </div>
          </div>
        </div>
        <div class="xl:col-3 sm:col-12">
          <div class="box box-stretched">
            <div class=" fluid">
              <app-personselector labelKey="Ответственный"
                                  [parentCompany]="globalSettinsData.mainCompanyId"
                                  [selectedID]="prod.PRODSALERID"
                                  (selectedPersonID)="prodSalerSelected($event)"
                                  [disabled]="notReady">
              </app-personselector>
              <small id="PPN1-help" class="p-warning red" *ngIf="!prodManagerValid">ВНИМАНИЕ! Выберите ответственного за продукт</small>
            </div>
            <div class="grid">
              <div class="field xl:col-4 sm:col-6 mt-2">
                <p-checkbox name="PPO"
                            label="Устаревший продукт"
                            [binary]="true"
                            [trueValue]="1"
                            [falseValue]="0"
                            [(ngModel)]="prod.PRODOBSOLETE"
                            (onChange)="onStatusChange($event)"
                            [styleClass]="hasChangedProperty('PRODCUSTCODE') ? 'field-changed' : ''"
                            [disabled]="notReady">
                </p-checkbox>
              </div>
              <div class="field xl:col-4 sm:col-6 mt-2">
                <p-checkbox name="PCN"
                            label="Сборное изделие"
                            [binary]="true"
                            [trueValue]="1"
                            [falseValue]="0"
                            [(ngModel)]="prod.PRODKIND"
                            (onChange)="onKindChange($event)"
                            [styleClass]="hasChangedProperty('PRODCUSTCODE') ? 'field-changed' : ''"
                            [disabled]="notReady || !editCodeAllowed">
                </p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[0]" [cache]="false" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabProdInfo id="atabProdInfo">Информация о цене и наличии</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
      </p-button>

      <!--          <app-product-info [prodId]="_prodId"></app-product-info>-->
      <app-product-info appStopAccordionHomeEnd [product]="kickChanges"></app-product-info>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[1]" [disabled]="prod.PRODKIND === 0" *ngIf="prod.PRODKIND !== 0" [cache]="false">
      <ng-template pTemplate="header">
        <h5 #atabBillOfMaterial id="atabBillOfMaterial">Состав</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'bom'" (onClick)="copyClipBoard(baseURL+'bom');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'bom'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <app-edit-product-parts appStopAccordionHomeEnd [product]="prod" (prodPartsUpdated)="onProdPartsUpdated($event)" *ngIf="prod.PRODKIND === 1"></app-edit-product-parts>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[9]" [disabled]="prod.PRODKIND !== 0" [cache]="false">
      <ng-template pTemplate="header">
        <h5 #atabParentProducts id="atabParentProducts">Используется в товарах</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'use'" (onClick)="copyClipBoard(baseURL+'use');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'use'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <app-list-product-array appStopAccordionHomeEnd [products]="parentProducts" [showToolBar]="false" noData="Товаров не найдено..." state="createPriceListState"></app-list-product-array>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[2]" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabBooking id="atabBooking">Резервирование и склад</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'booking'" (onClick)="copyClipBoard(baseURL+'booking');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'booking'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <div class="fluid formgrid grid" *ngIf="prodInfo as pInfo else piloading" appStopAccordionHomeEnd>
        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PI1" class="do-not-wrap-text">На складе</label>
          <input id="PI1" type="number" pInputText [value]="pInfo.PRODSTOCK" readonly />
        </div>
        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PI2" class="do-not-wrap-text">Продано</label>
          <input id="PI2" type="number" pInputText [value]="pInfo.PRODSOLD" readonly />
        </div>

        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PI3" class="do-not-wrap-text">В резерве</label>
          <input id="PI3" type="number" pInputText [value]="pInfo.PRODRESERVE" readonly />
        </div>

        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PI4" class="do-not-wrap-text">В пути</label>
          <input id="PI4" type="number" pInputText [value]="pInfo.PRODONWAY" readonly />
        </div>
      </div>
      <ng-template #piloading>
        <p>Информация о резервировании загружается...</p>
      </ng-template>

      <div *ngIf="booking as pBook else pbLoading" class="mt-2 mb-2" appStopAccordionHomeEnd>
        <p-table #prodBookingInfo
                 id="prodBookingInfo"
                 [value]="pBook"
                 [rowHover]="true"
                 [resizableColumns]="true"
                 selectionMode="single"
                 [(selection)]="selectedBooking"
                 dataKey="DOCID"
                 sortField="RESERVEDTILL"
                 styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
                 (onRowSelect)="onRowSelect($event)"
                 (onRowUnselect)="onRowUnselect($event)">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="LOCCOMP" pResizableColumn width="15%" class="do-not-overlay-text">Продавец <p-sortIcon field="LOCCOMP"></p-sortIcon></th>
              <th pSortableColumn="DOCNUMBER" pResizableColumn width="8%" class="do-not-overlay-text">Счет <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
              <th pSortableColumn="DOCDATE" pResizableColumn width="7%" class="do-not-overlay-text">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
              <th pSortableColumn="CLIENTSNAME" pResizableColumn width="15%" class="do-not-overlay-text">Покупатель <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
              <th pSortableColumn="INPROD" pResizableColumn class="do-not-overlay-text">В составе <p-sortIcon field="INPROD"></p-sortIcon></th>
              <th pSortableColumn="ORDERED" pResizableColumn width="8%" class="do-not-overlay-text">Количество в счете <p-sortIcon field="ORDERED"></p-sortIcon></th>
              <th pSortableColumn="SHIPPED" pResizableColumn width="8%" class="do-not-overlay-text">Отгружено <p-sortIcon field="SHIPPED"></p-sortIcon></th>
              <th pSortableColumn="DEBTS" pResizableColumn width="8%" class="do-not-overlay-text">Долг <p-sortIcon field="DEBTS"></p-sortIcon></th>
              <th pSortableColumn="MANUED" pResizableColumn width="8%" class="do-not-overlay-text">В производстве <p-sortIcon field="MANUED"></p-sortIcon></th>
              <th pSortableColumn="RESERVEDTILL" pResizableColumn width="10%" class="do-not-overlay-text">Резерв до <p-sortIcon field="PARTNAME"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-pBook>
            <tr [pSelectableRow]="pBook">
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.LOCCOMP | pipetrimstr }}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-document', 1, pBook.DOCID]">{{pBook.DOCNUMBER }}</a>
              </td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                {{pBook.DOCDATE | date:'dd.MM.yyyy' }}
              </td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.CLIENTSNAME | pipetrimstr }}</td>

              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-product', pBook.PRODID]">{{pBook.INPROD | pipetrimstr }}</a>
              </td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.ORDERED | number:'1.0-2' }}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.SHIPPED | number:'1.0-2' }}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.DEBTS | number:'1.0-2' }}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.MANUED | number:'1.0-2' }}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.RESERVEDTILL | pipetrimstr }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">На данный момент нет резервирования</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <ng-template #pploading>
        <p>Информация о резервировании загружается...</p>
      </ng-template>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[3]" [disabled]="!tabAnalyticEnable || (analiticsIsReady == false)" *ngIf="_prodId && canEditPrice">
      <ng-template pTemplate="header">
        <h5 #atabAnalytic id="atabAnalytic">История заказов</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <div class="fluid grid ">
        <div class="p-flex-row col-12">
          <!--[options]="optionsDailyPayments"-->
          <p-chart type="bar" [data]="dataProductAnalytic" (onDataSelect)="selectProductAnalyticsData($event)" width="100%" height="20rem"></p-chart>
        </div>
      </div>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[4]" [disabled]="!tabPriceEnable" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabPriceCalculation id="atabPriceCalculation">Расчет цены (поставщики)</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <div class="grid formgrid mb-2" appStopAccordionHomeEnd>
        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PPI1" class="do-not-wrap-text">НДС (%)</label>
          <input id="PPI1" type="number" pInputText [value]="prod.PRODVAT" [(ngModel)]="prod.PRODVAT"
                 min="0" step="1" style="text-align: right" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODVAT')" />
        </div>
        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PPI2" class="do-not-wrap-text">Мин скидка (%)</label>
          <input id="PPI2" type="number" pInputText [value]="prod.PRODBASEDISC" [(ngModel)]="prod.PRODBASEDISC"
                 min="0" step="1" style="text-align: right" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODBASEDISC')" />
        </div>

        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PPI3" class="do-not-wrap-text">Скидка на количестве (%)</label>
          <input id="PPI3" type="number" pInputText [value]="prod.PRODQTYDISC" [(ngModel)]="prod.PRODQTYDISC"
                 min="0" step="1" style="text-align: right" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODQTYDISC')" />
        </div>

        <div class="field col-2 xl:col-2 sm:col-3 ">
          <label for="PPI4" class="do-not-wrap-text">Партнерская скидка (%)</label>
          <input id="PPI4" type="number" pInputText [value]="prod.PRODDIALDISC" [(ngModel)]="prod.PRODDIALDISC"
                 min="0" step="1" style="text-align: right" [disabled]="notReady"
                 [class.field-changed]="hasChangedProperty('PRODDIALDISC')" />
        </div>
      </div>
      <div class="grid formgrid justify-content-end mb-2">
        <p-button label="Reload" icon="pi pi-refresh" styleClass="p-button-secondary mb-2 mr-2" (onClick)="vendorsEditor.reloadProdVendors()"
                  [loading]="vendorsEditor.reloading" [disabled]="vendorsEditor.editMode"
                  pTooltip="Reload the vendor rows and their prices from the database" tooltipPosition="top"></p-button>
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(4)" styleClass="mb-2 mr-2" [disabled]="noChangesThere"></p-button>
      </div>
      <app-edit-product-vendors #vendorsEditor appStopAccordionHomeEnd [product]="prod" (productVendor)="onSetMainPriceRow($event)" (productPriceUpdate)="onProductPriceUpdate($event)"></app-edit-product-vendors>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[5]" styleClass="">
      <ng-template pTemplate="header">
        <h5 #atabRowInfo id="atabRowInfo">Row info</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field xl:col-1 sm:col-12">
          <label for="PR1" class="do-not-wrap-text">PRODID</label>
          <input id="PR1" type="number" pInputText [value]="prod.PRODID" />
        </div>
        <div class="field xl:col-1 sm:col-6">
          <label for="PR2" class="do-not-wrap-text">PRODVENDORID</label>
          <input id="PR2" type="number" pInputText [value]="prod.PRODVENDORID" />
        </div>

        <div class="field xl:col-1 sm:col-6">
          <label for="PR3" class="do-not-wrap-text">PRODSALERID</label>
          <input id="PR3" type="number" pInputText [value]="prod.PRODSALERID" />
        </div>

        <div class="field xl:col-1 sm:col-6">
          <label for="PR4" class="do-not-wrap-text">PRODGROUP</label>
          <input id="PR4" type="number" pInputText [value]="prod.PRODGROUP" />
        </div>
        <div class="field xl:col-1 sm:col-6">
          <label for="PR5" class="do-not-wrap-text">PRODEUPRICEID</label>
          <input id="PR5" type="number" pInputText [value]="prod.PRODEUPRICEID" />
        </div>
        <div class="field xl:col-1 sm:col-6">
          <label for="PR6" class="do-not-wrap-text">PRODKIND</label>
          <input id="PR6" type="number" pInputText [value]="prod.PRODKIND" />
        </div>

      </div>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[7]" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabAllStocks id="atabAllStocks">Остатки по всем складам</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <app-product-list-stocks appStopAccordionHomeEnd [prodId]="_prodId"></app-product-list-stocks>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[6]" [disabled]="!tabTurnoverEnable" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabTurnOverSheet id="atabTurnOverSheet">Оборотная ведомость</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'main'" (onClick)="copyClipBoard(baseURL+'main');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'main'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <app-turnover-sheet-table appStopAccordionHomeEnd [prodId]="_prodId" state="productTurnOverSheet-state" [depth]="6"></app-turnover-sheet-table>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сбросить" icon="pi pi-undo" (onClick)="clearOrResetTableFilter($event)" styleClass="mt-2 mr-2"></p-button>
        <p-button label="Открыть отчет" icon="pi pi-check" (onClick)="onGoToTurnoverPage($event)" styleClass="mt-2 mr-2"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[8]" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabAllDocuments id="atabAllDocuments">Все документы по товару</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'documents'" (onClick)="copyClipBoard(baseURL+'documents');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'documents'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <!--        <app-list-documents-for-product [prodId]="_prodId"></app-list-documents-for-product>-->
      <app-list-documents-for-product appStopAccordionHomeEnd [product]="prod"></app-list-documents-for-product>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[11]" [cache]="false" *ngIf="_prodId">
      <ng-template pTemplate="header">
        <h5 #atabSerials id="atabSerials">Серийные номера</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'serials'" (onClick)="copyClipBoard(baseURL+'serials');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'serials'}}' в буфер обмена" tooltipPosition="top">
        </p-button>
      </ng-template>
      <app-product-serials-table appStopAccordionHomeEnd [product]="prod"></app-product-serials-table>
    </p-accordionTab>

  </p-accordion>
  <p-scrollTop />
</div>
<ng-template #loading>
  <p>Информация загружается...</p>
</ng-template>
